exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".elesigncode-content>div>canvas{display:inline-block;background:#f7f8fa;border-radius:.04rem}", ""]);

// exports
